import { Button, type ButtonProps, forwardRef } from "@chakra-ui/react";
import { Icon } from "@src/components/ui-kit/Icon";
import type { FunctionComponent } from "react";

export const DropdownButton: FunctionComponent<ButtonProps> = forwardRef(
  (props, ref) => {
    return (
      <Button
        colorScheme="grey"
        rightIcon={<Icon name="chevron-down" />}
        variant="outline"
        {...props}
        ref={ref}
      />
    );
  },
);
